module.exports = __webpack_public_path__ + "static/img/hangye2.28546a22.svg";